const keywords = [
  '黑料最新',
  '黑料最新预告',
  '黑料最新下期爆料',
  '黑料最新待证实',
  '黑料最新线人消息',
];

export default function HeroSection() {
  return (
    <section id="top" className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap items-center gap-3">
              <span className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1 font-label text-xs text-foreground-700">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                第 130 期 · 预告版
              </span>
              <span className="font-label text-xs text-foreground-500">
                每日 09:00 更新
              </span>
            </div>

            <h1 className="mt-6 font-heading text-3xl font-black leading-[1.22] tracking-tight text-foreground-950 md:text-5xl md:leading-[1.2]">
              <span className="mb-3 block font-label text-sm font-medium tracking-[0.3em] text-primary-600">
                黑料最新
              </span>
              预告：下期爆料蹲一个，待证实线人消息，提前听风声
            </h1>

            <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-foreground-700 md:text-lg">
              黑料最新预告，下期爆料提前蹲一个。待证实消息与线人风声抢先透露，给你留足悬念。想比别人更早嗅到风向？关注预告区，第一时间掌握即将引爆的猛料。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#next"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                蹲一个下期预告
                <i className="ri-arrow-right-line text-base" />
              </a>
              <a
                href="#unconfirmed"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 font-label text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                先看待证实消息
              </a>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-2 border-t border-background-200/70 pt-6">
              <span className="mr-1 font-label text-xs text-foreground-500">本期关键词</span>
              {keywords.map((word) => (
                <span
                  key={word}
                  className="rounded-full border border-secondary-200 bg-secondary-100/70 px-3 py-1 font-label text-xs text-secondary-900"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative">
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20layered%20torn%20paper%20and%20newspaper%20texture%20in%20warm%20amber%20and%20deep%20brick%20red%20tones%2C%20dramatic%20side%20lighting%2C%20stylized%20minimal%20composition%2C%20grainy%20film%20texture%2C%20high%20contrast%2C%20no%20text%2C%20moody%20cinematic&width=900&height=1100&seq=heimao-hero-01&orientation=portrait"
                  alt="黑料最新预告封面"
                  title="黑料最新 预告 下期爆料 封面"
                  className="h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-medium text-foreground-950">
                    <i className="ri-timer-flash-line text-sm" />
                    今日悬念
                  </span>
                  <p className="mt-3 font-heading text-lg font-bold leading-snug text-background-50">
                    一段正在核验的录音，牵出档期与分成的第一手时间线
                  </p>
                  <p className="mt-1 font-label text-xs text-background-200">
                    待证实 · 预计 48 小时内放料
                  </p>
                </div>
              </div>
              <div className="mt-4 flex items-center justify-between rounded-lg border border-background-200 bg-background-100/70 px-4 py-3">
                <span className="font-label text-xs text-foreground-600">本期待证实</span>
                <span className="font-heading text-sm font-bold text-foreground-950">4 条</span>
                <span className="h-4 w-px bg-background-300" />
                <span className="font-label text-xs text-foreground-600">在线线人</span>
                <span className="font-heading text-sm font-bold text-foreground-950">96 位</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}